import React, { useState } from 'react'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { useApiListAnalyticPeriod, useApiListAnalyticTopic } from '../../../../../api-new/state/analytics'
import { useLoad } from '../../../../../shared/hooks/load'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { Period } from '../period'
import { IconCalender } from '../../../../../shared/icon/icon'
import { VisTimelineEventPeriod } from '../vis-graph/vis-timeline-event-period'
import { useTrackingMarkers } from './tracking-markers'

// The "topic/analytic changed" markers are each topic's History with its
// analytics (audit phase 6, Task 19; tracking-markers.js).

export const TimelineAll = () => {
  const { nodeID } = useParamsInt()

  const apiListAnalyticPeriod = useApiListAnalyticPeriod()
  const apiListAnalyticTopic = useApiListAnalyticTopic()

  const [selectedPeriodID, updateSelectedPeriodID] = useState()

  useLoad(() => apiListAnalyticPeriod.get(`${nodeID}/node`), [nodeID])
  useLoad(() => apiListAnalyticTopic.get(`${nodeID}/node`), [nodeID])

  const markers = useTrackingMarkers((apiListAnalyticTopic.items || []).map(topic => ({ record: `analytic_topics:${topic.id}`, children: '1' })))

  const handleLoadPeriod = () => apiListAnalyticPeriod.get(`${nodeID}/node`)

  return (
    <BreadcrumbView text="Timeline" Icon={IconCalender}>
      <CardFullHeightScrollY>
        <VisTimelineEventPeriod
          topics={markers.topics}
          analytics={markers.analytics}
          periods={apiListAnalyticPeriod.items}
          onSelectPeriod={updateSelectedPeriodID}
        />
        <Period apiList={apiListAnalyticPeriod} selectedPeriodID={selectedPeriodID} onLoad={handleLoadPeriod} />
      </CardFullHeightScrollY>
    </BreadcrumbView>
  )
}
